@if (showTable) {
  <sd-component-wrapper [content]="wrapperContent" [themesConfig]="lameConfig?.backgroundTheme">
    @if (showTable) {
      <ng-container sd-component-wrapper-component>
        <wc-base-comparator
          [productCodes]="productCodes"
          [compareOnLoad]="true"
          [isReadOnlyAccordion]="true"
          [isReadOnly]="true"
        />
      </ng-container>
    }
  </sd-component-wrapper>
}
